import { collection, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export const UpdateAllDocuments = async (collectionName) => {
    const docs = (await getDocs(collection(db, collectionName))).docs.map(elem => elem);

      for (const documentData of docs) {
        try {
            const docRef = await updateDoc(documentData.ref, { removed: true});
            console.log("Document written with ID: ", docRef.id);
          } catch (e) {
            console.error("Error adding document: ", e);
          }
      }

};
//                 removed: true